<template>
  <div class="shop-card-detail-counter">
    <div class="image">
      <img class="img-cell-l" fit="cover" :src="imgData" v-if="imgData && imgData.startsWith('data:image')" />
    </div>
    <div class="card-customer-info">
      <div class="card-info">
        <span>{{ $t('cardInfo') }}</span>
        <span>{{ $route.query.cardName }}</span>
      </div>
      <div class="card-info">
        <span>{{ $t('employeeInfo') }}</span>
        <span>{{ $route.query.customerId }}</span>
      </div>
      <!-- <div class="card-info">
        <span>{{ $t('mainCard') }}</span>
        <van-switch
          inactive-color="#dcdee0"
          @change="handleChangeSwitch"
          v-model="isMaster"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      imgData: "",
      timer: null,
      isMaster: this.$route.query.isMaster == 1,
    };
  },
  computed: {},
  mounted() {
    this.getPayCodeload();
    this.timer = setInterval(() => {
      this.getPayCodeload();
    }, 1000 * 60 * 2);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getPayCodeload() {
      if (!this.$route.query.id) return;
      this.$authAjax
        .get(`/api/wxapp/cardimg/${this.$route.query.id}`)
        .then((res) => {
          if (res.data.code == 200) {
            this.imgData = `data:image/jpeg;base64,${res.data.data}`;
          } else {
            this.$toast(res.data.message);
          }
        });
    },
    async handleChangeSwitch(e) {
      if (e && this.$route.query.isMaster == 0) {
        await Dialog.confirm({
          title: this.$t('merchantTitle'),
          message: this.$t('switchTips'),
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('orderCancel')
        });
        const res = await this.$authAjax.post("/api/wxapp/generateToken2", {
          shopId: this.$route.query.shopId,
        });

        const resData = res.data.data;

        const accessToken = resData.accessToken;
        localStorage.setItem("token", accessToken);
        localStorage.setItem("shopId", this.$route.query.shopId);

        // 刷新
        // 跳转路由
        const url = `${location.origin}/${location.pathname}/#/?code=${resData.code}`;

        window.location.replace(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-card-detail-counter {
  padding: 16px;
  height: 100vh;
  background: #f8f8f8;
  box-sizing: border-box;
  overflow: auto;
  .image {
    width: 200px;
    height: 200px;
    margin: 85px auto;
    .img-cell-l {
      width: 200px;
      height: 200px;
    }
  }
  .card-customer-info {
    padding: 0 12px;
    background: #fff;
    border-radius: 6px;
    .card-info {
      padding: 14px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      color: #333;
    }
  }
}
</style>